// import React from 'react';

// import { MainOutLet } from './mainLayOut';

// import ChatApp from '../screens/App/ChatApp';

// import Page404 from '../components/Auth/Page404';
// import PermissionDenied from '../components/Auth/PermissionDenied';

// import Members from '../screens/Admin/Members';
// import Holidays from '../screens/Admin/Holidays';
// import LeaveType from '../screens/Admin/LeaveType';
// import LeaveRequest from '../screens/Admin/LeaveRequest';
// import LeaveBalance from '../screens/Admin/LeaveBalance';
// import AdminProfile from '../screens/Admin/AdminProfile';
// import AnnouncementAdmin from '../screens/Admin/AnnouncementAdmin';
// import AttendanceTimeTracking from '../screens/Admin/AttendanceTimeTracking';
// import AttendanceEmployees from '../screens/Admin/AttendanceTimeDoctor';

// import EmployeeProfile from '../screens/Employee/EmployeeProfile';
// import EmployeeFile from '../screens/Employee/EmployeeFile';
// import AnnouncementEmployee from '../screens/Employee/AnnouncementEmployee';
// import Payrun from '../screens/Admin/Payrun';
// import SupportTicket from '../screens/Admin/SupportTicket';
// import ComplainList from '../screens/Admin/Complain/ComplainList';
// import EmployeeAssets from '../screens/Admin/EmployeeAssets';
// import Dashboard from '../screens/Dashboard/Dashboard';
// import CalendarView from '../screens/Admin/Calendar';
// import KPIList from '../screens/Admin/kpi';
// import PerformanceList from '../screens/Admin/Performance/PerformanceList';
// import LopAndOvertimeRequestList from '../screens/Admin/LopAndOvertimeRequest';
// import { ROLES } from '../utils/constant/global';
// import AttendanceLogApprovalList from '../screens/Admin/attendanceLogApproval';
// import HRXAttendance from '../screens/Employee/HRXAttendance';
// import SystemRoleList from '../screens/Admin/systemRoles/SystemRoleList';
// import SystemRoleDetails from '../screens/Admin/systemRoles/SystemRoleDetails';

// const { ADMIN, MANAGEMENT, EMPLOYEE, LEAD } = ROLES;

// export const privateRoutes = [
//   {
//     path: '/',
//     element: <MainOutLet />,
//     roles: [ADMIN],
//     children: [
//       { path: 'dashboard', element: <Dashboard /> },
//       { path: 'employees', element: <Members /> },
//       { path: 'attendance-approval', element: <AttendanceLogApprovalList /> },
//       { path: 'attendance-employees', element: <AttendanceEmployees /> },
//       { path: 'hrx-employee-attendance', element: <HRXAttendance /> },
//       { path: 'attendance-time-tracking', element: <AttendanceTimeTracking /> },
//       { path: 'leave-balance', element: <LeaveBalance /> },
//       { path: 'leave-request', element: <LeaveRequest /> },
//       { path: 'leave-type', element: <LeaveType /> },
//       { path: 'holidays', element: <Holidays /> },
//       { path: 'support-ticket', element: <SupportTicket /> },
//       { path: 'complaints', element: <ComplainList /> },
//       { path: 'chat-app', element: <ChatApp /> },
//       { path: 'profile', element: <AdminProfile /> },
//       { path: 'announcement', element: <AnnouncementAdmin /> },
//       { path: 'payrun', element: <Payrun /> },
//       { path: 'lop-overtime-request', element: <LopAndOvertimeRequestList /> },
//       { path: 'employee-assets', element: <EmployeeAssets /> },
//       { path: 'calendar', element: <CalendarView /> },
//       { path: 'kpi-list', element: <KPIList /> },
//       { path: 'performance-list', element: <PerformanceList /> },
//       { path: 'system-roles', element: <SystemRoleList /> },
//       { path: 'system-roles/:id', element: <SystemRoleDetails /> },
//       { path: 'permission-denied', element: <PermissionDenied /> },
//       { path: 'files', element: <EmployeeFile /> },

//       { path: '*', element: <Page404 /> }
//     ]
//   },
//   {
//     path: '/',
//     element: <MainOutLet />,
//     roles: [EMPLOYEE, LEAD, MANAGEMENT],
//     children: [
//       { path: 'dashboard', element: <Dashboard /> },
//       { path: 'profile', element: <EmployeeProfile /> },
//       { path: 'attendance-employees', element: <AttendanceEmployees /> },
//       { path: 'hrx-employee-attendance', element: <HRXAttendance /> },
//       { path: 'attendance-time-tracking', element: <AttendanceTimeTracking /> },
//       { path: 'leave-balance', element: <LeaveBalance /> },
//       { path: 'leave-request', element: <LeaveRequest /> },
//       { path: 'holidays', element: <Holidays /> },
//       { path: 'files', element: <EmployeeFile /> },
//       { path: 'payrun', element: <Payrun /> },
//       { path: 'announcement', element: <AnnouncementEmployee /> },
//       { path: 'support-ticket', element: <SupportTicket /> },
//       { path: 'complaints', element: <ComplainList /> },
//       { path: 'lop-overtime-request', element: <LopAndOvertimeRequestList /> },
//       { path: 'performance-list', element: <PerformanceList /> },
//       { path: 'chat-app', element: <ChatApp /> },
//       { path: 'permission-denied', element: <PermissionDenied /> },
//       { path: '*', element: <Page404 /> }
//     ]
//   },
//   // {
//   //   path: '/permission-denied',
//   //   // element: <MainOutLet />,
//   //   // roles: [EMPLOYEE, LEAD, MANAGEMENT],
//   //   children: [{ path: '', element: <PermissionDenied /> }]
//   // }
// ];

import React from 'react';

// import { MainOutLet } from './mainLayOut';

import ChatApp from '../screens/App/ChatApp';

// import Page404 from '../components/Auth/Page404';
// import PermissionDenied from '../components/Auth/PermissionDenied';

import Members from '../screens/Admin/Members';
import EmployeeDetails from '../screens/Admin/EmployeeDetails';
import Files from '../screens/Admin/Files';
import Holidays from '../screens/Admin/Holidays';
import LeaveType from '../screens/Admin/LeaveType';
import LeaveRequest from '../screens/Admin/LeaveRequest';
import LeaveBalance from '../screens/Admin/LeaveBalance';
import AdminProfile from '../screens/Admin/AdminProfile';
import AnnouncementAdmin from '../screens/Admin/AnnouncementAdmin';
import AnnouncementFormPage from '../screens/Admin/AnnouncementFormPage';
import AttendanceTimeTracking from '../screens/Admin/AttendanceTimeTracking';
import AttendanceOverview from '../screens/Admin/AttendanceOverview';
import AttendanceEmployees from '../screens/Admin/AttendanceTimeDoctor';

import EmployeeProfile from '../screens/Employee/EmployeeProfile';
import EmployeeFile from '../screens/Employee/EmployeeFile';
// import AnnouncementEmployee from '../screens/Employee/AnnouncementEmployee';
import Payrun from '../screens/Admin/Payrun';
import SupportTicket from '../screens/Admin/SupportTicket';
import ComplainList from '../screens/Admin/Complain/ComplainList';
import ContactUsList from '../screens/Admin/ContactUs/ContactUsList';
import RoomBooking from '../screens/Admin/RoomBooking/RoomBooking';
import EmployeeAssets from '../screens/Admin/EmployeeAssets';
import Dashboard from '../screens/Dashboard/Dashboard';
// import CalendarView from '../screens/Admin/Calendar';
import KPIList from '../screens/Admin/kpi';
import PerformanceList from '../screens/Admin/Performance/PerformanceList';
import LopAndOvertimeRequestList from '../screens/Admin/LopAndOvertimeRequest';
// import { ROLES } from '../utils/constant/global';
// import AttendanceLogApprovalList from '../screens/Admin/attendanceLogApproval';
import AttendanceViolationList from '../screens/Admin/AttendanceViolation';
import TimeEditRequestList from '../screens/Admin/timeEditRequest';
import HRXAttendance from '../screens/Employee/HRXAttendance';
import SystemRoleList from '../screens/Admin/systemRoles/SystemRoleList';
import SystemRoleDetails from '../screens/Admin/systemRoles/SystemRoleDetails';
import GoogleCalendar from '../screens/Admin/googleCalendar/googleCalendar';
import OrgChartComponent from '../screens/App/OrgChart';
import NotificationsPage from '../screens/Notifications/NotificationsPage';

// const { ADMIN, EMPLOYEE, LEAD, MANAGEMENT } = ROLES;
export const privateRoutes = [
  { path: '/dashboard', element: <Dashboard /> },
  { path: '/notifications', element: <NotificationsPage /> },
  { path: '/employees', element: <Members /> },
  { path: '/employees/:id/files', element: <Files /> },
  { path: '/employees/:id', element: <EmployeeDetails /> },
  // { path: '/attendance-approval', element: <AttendanceLogApprovalList /> },
  { path: '/attendance-employees', element: <AttendanceEmployees /> },
  { path: '/hrx-employee-attendance', element: <HRXAttendance /> },
  { path: '/attendance-time-tracking', element: <AttendanceTimeTracking /> },
  { path: '/attendance-overview', element: <AttendanceOverview /> },
  { path: '/attendance-violations', element: <AttendanceViolationList /> },
  { path: '/time-edit-requests', element: <TimeEditRequestList /> },
  { path: '/leave-balance', element: <LeaveBalance /> },
  { path: '/leave-request', element: <LeaveRequest /> },
  { path: '/leave-type', element: <LeaveType /> },
  { path: '/holidays', element: <Holidays /> },
  // { path: '/calendar', element: <CalendarView /> },
  { path: '/calendar', element: <GoogleCalendar /> },

  { path: '/support-ticket', element: <SupportTicket /> },
  { path: '/complaints', element: <ComplainList /> },
  { path: '/contact-submissions', element: <ContactUsList /> },
  { path: '/room-booking', element: <RoomBooking /> },
  { path: '/chat-app', element: <ChatApp /> },
  { path: '/profile', element: <AdminProfile /> },
  { path: '/employee-profile', element: <EmployeeProfile /> },
  // { path: '/announcement-admin', element: <AnnouncementAdmin /> },
  { path: '/announcement', element: <AnnouncementAdmin /> },
  { path: '/announcement/create', element: <AnnouncementFormPage /> },
  { path: '/announcement/edit/:id', element: <AnnouncementFormPage /> },
  { path: '/payrun', element: <Payrun /> },
  { path: '/lop-overtime-request', element: <LopAndOvertimeRequestList /> },
  { path: '/employee-assets', element: <EmployeeAssets /> },
  { path: '/files', element: <EmployeeFile /> },
  { path: '/kpi-list', element: <KPIList /> },
  { path: '/performance-list', element: <PerformanceList /> },
  { path: '/system-roles', element: <SystemRoleList /> },
  { path: '/system-roles/:id', element: <SystemRoleDetails /> },
  { path: '/organization-tree', element: <OrgChartComponent /> }

  // { path: '/permission-denied', element: <PermissionDenied /> },
];
